import { render, staticRenderFns } from "./orderManagementDetail.vue?vue&type=template&id=1083cb29&scoped=true"
import script from "./orderManagementDetail.vue?vue&type=script&lang=js"
export * from "./orderManagementDetail.vue?vue&type=script&lang=js"
import style0 from "./orderManagementDetail.vue?vue&type=style&index=0&id=1083cb29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1083cb29",
  null
  
)

export default component.exports